import axios from 'axios';

axios.defaults.validateStatus = function (status) {
    return status >= 200 && status < 300;
}

// Use environment variable or production URL
const apiBaseURL = process.env.REACT_APP_API_URL || 'https://cmk.arue.pl/api/';

const params = {
    baseURL: apiBaseURL
};

let api = axios.create(params);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const baseURL = apiBaseURL;

export default api;


// WEBPACK FOOTER //
// ./src/axios-cmk.js